<script>
import resources from './resources'
import '@desislavsd/vue-select/dist/vue-select.css'

export default {
  name: 'unit-form',
  mixins: [resources]
}
</script>

<template lang="pug">
  section.content
    .container-fluid
      .block-header
        .row
          .col-lg-5.col-md-5.col-sm-12
            h2 Veículos
            ul.breadcrumb.padding-0
              li.breadcrumb-item
                a(href='index.html')
                  i.zmdi.zmdi-home
              li.breadcrumb-item
                a(href='javascript:void(0);') Veículos
              li.breadcrumb-item.active Cadastro
          //-.col-lg-7.col-md-7.col-sm-12
            .input-group.m-b-0
              input.form-control(
                type='text',
                placeholder='Localizar Carro',
                disabled
              )
              span.input-group-addon
                i.zmdi.zmdi-search

      .row.clearfix
        .col-lg-12.col-md-12.col-sm-12
          .card
            .header
              h2
              ul.header-dropdown
                li.dropdown(:class="{'show': show}")
                  a.dropdown-toggle(@click.prevent="showActions(show)", href='javascript:void(0);')
                    i.zmdi.zmdi-more
                  ul.dropdown-menu.dropdown-menu-right(:class="{'show': show}")
                    li
                      router-link(:to="{name: 'tenant.car.index'}") Listagem
                    li
                     router-link(:to="{name: 'tenant.car.create'}") Cadastro
            .body
              .row.clearfix
                .col-lg-4.col-md-4
                  .form-group
                    v-input(:status="$v.car.tower_id.$error ? 'error' : null")
                      f-select(
                        name="tower_id",
                        v-model="car.tower_id",
                        placeholder="Selecionar Torre"
                        :searchable="true",
                        :options="dwellerTowers",
                        label-by="number",
                        @selected="selectUnitsTower"
                    )
                .col-lg-4.col-md-4
                  .form-group
                    v-input(:status="$v.car.unit_id.$error ? 'error' : null")
                      f-select(
                        name="unit_id",
                        v-model="car.unit_id",
                        :searchable="true",
                        :multiple="false"
                        placeholder="Selecionar unidade"
                        :options="dwellerUnits",
                        label-by="number"
                      )
                .col-lg-4.col-md-4
                  .form-group
                    v-input(:status="$v.car.unit_id.$error ? 'error' : null")
                      input.form-control(
                        type='text',
                        placeholder='Placa',
                        v-model="car.plate"
                      )
                .col-lg-4.col-md-4
                  .form-group
                    v-input(:status="$v.car.model.$error ? 'error' : null")
                      input.form-control(
                        type='text',
                        placeholder='Modelo',
                        v-model="car.model"
                      )
                .col-lg-4.col-md-4
                  .form-group
                    v-input(:status="$v.car.color.$error ? 'error' : null")
                      input.form-control(
                        type='text',
                        placeholder='Cor',
                        v-model="car.color"
                      )
                .col-md-12
                  button.btn.btn-raised.btn-primary.btn-round.waves-effect(
                    type='button',
                    @click.prevent="doSave()",
                  ) Salvar
</template>
<style scoped>
.color-red {
  color: #f96332;
}
</style>



// WEBPACK FOOTER //
// src/app/tenant/car/form/form.vue